import {
  AlphaAvatar,
  BraveAvatar,
  CosmicAvatar,
  CreativeAvatar,
  GeekAvatar,
} from '@/shared/assets';

import { IAvatar } from '../model/types';

export const mockAvatars: IAvatar[] = [
  {
    imageSrc: BraveAvatar,
    name: 'Brave',
  },
  {
    imageSrc: CreativeAvatar,
    name: 'Creative',
  },
  {
    imageSrc: GeekAvatar,
    name: 'Geek',
  },
  {
    imageSrc: AlphaAvatar,
    name: 'Alpha',
  },
  {
    imageSrc: CosmicAvatar,
    name: 'Cosmic',
  },
];
